import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { sanitizeListRestProps } from 'ra-core';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import {TextField} from 'react-admin';
import classnames from 'classnames';
import DatagridHeaderCell from './DatagridHeaderCell';
import DatagridBody from 'ra-ui-materialui/lib/list/DatagridBody';

import { Close } from '@material-ui/icons';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

import { connect } from 'react-redux';

import { tableStyles } from '../../stylization/SecretarTheme';
import AddButton from '../AddButton';
import SecretaryEditButton from '../SecretaryEditButton';
import {restClient} from '../../common';

import {triggerCreate as triggerCreateAction, triggerEdit as triggerEditAction } from '../../redux/actions';
import { refreshView as refreshViewAction } from 'react-admin';
import { showNotification } from 'react-admin';

let Datagrid = class extends Component {
  constructor (props) {
    super(props);
    this.state = {
      record: null
    };
    this.toggleDrawer.bind(this);
  }

  toggleDrawer = (where, open, record) => () => {
    this.setState({
        record: record
      }, () => {
        if (where === 'create') {
          this.props.triggercreate(open);
        } else if (where === 'edit') {
          this.props.triggeredit(open);
        }
      }
    );
  }

  submit = values => {
    restClient('GET_CUSTOM_POST', this.props.resource, values).then(res => {
      // todo refactor
      if (this.props.createopen) {
        this.props.triggercreate(false);
      } else if (this.props.editopen) {
        this.props.triggeredit(false);
      }
      this.props.refreshView();
    }).catch((httpError) => {
      this.props.showNotification(httpError.message, 'warning');
    });
  }

  getCloseBtn = (click) => (
    <div onClick={click} style={{position: 'fixed', right: '31px', top: '65px', cursor: 'pointer' }}>
      <Close style={{fill: '#2c9bc3', width: '30px', height: '30px' }}/>
    </div>
  )

  updateSort = event => {
    event.stopPropagation();
    this.props.setSort(event.currentTarget.dataset.sort);
  };

  handleSelectAll = event => {
    const { onSelect, ids, selectedIds } = this.props;
    if (event.target.checked) {
      onSelect(
        ids.reduce(
          (idList, id) =>
            idList.includes(id) ? idList : idList.concat(id),

          selectedIds
        )
      );
    } else {
      onSelect([]);
    }
  };

  render() {
    const {
      basePath,
      data,
      children,
      classes,
      className,
      currentSort,
      hasBulkActions,
      hover,
      ids,
      isLoading,
      resource,
      rowStyle,
      selectedIds,
      setSort,
      onSelect,
      onToggleItem,
      total,
      version,
      create,
      edit,
      editopen,
      createopen,
      triggercreate,
      triggeredit,
      refreshView,
      showCounters,
      tableCounters,
      showNotification,
      ...rest
    } = this.props;

    let showTable = true;
    if (!isLoading && (ids.length === 0 || total === 0)) {
      //return null;
      showTable = false;
    }

    return (
      <div style={{ position: 'relative' }}>
        {create && <SwipeableDrawer
          anchor="left"
          open={createopen}
          onClose={this.toggleDrawer('create', false)}
          onOpen={() => {}}
        >
          <div
            role="button"
          >
            {create(this.submit.bind(this))}
            { this.getCloseBtn(this.toggleDrawer('create', false)) }
          </div>
        </SwipeableDrawer>}

        {edit && <SwipeableDrawer
          anchor="left"
          open={editopen}
          onClose={this.toggleDrawer('edit', false)}
          onOpen={() => {}}
        >
          <div
            role="button"
          >
            {edit(this.submit.bind(this), this.state.record)}
            { this.getCloseBtn(this.toggleDrawer('edit', false)) }
          </div>
        </SwipeableDrawer>}

        {showTable && <Table
          className={classnames(classes.table, className)}
          {...sanitizeListRestProps(rest)}
        >
          {showCounters && <TableHead>
            <TableRow className={classes.row}>
              {(create || edit ) && (
                <TableCell
                  className={classes.headerCell}
                  key='editActions'
                  //resource={resource}
                  style={{
                    color: '#2c9bc3',
                    width: '31px',
                    padding: 0
                  }}
                >

                </TableCell>
              )}

              {React.Children.map(
                children,
                (field, index) => {
                  const customStyles = field.props.customstyles ? field.props.customstyles : null;
                  return field ? (
                    <TableCell
                      className={classes.headerCell}
                      // currentSort={currentSort}
                      field={field}
                      // isSorting={
                      //   field.props.source ===
                      //   currentSort.field
                      // }
                      key={field.props.source || index}
                      // resource={resource}
                      // updateSort={this.updateSort}
                      style={{color: customStyles.background, background: '#fff'}}
                      // className={classnames(className, field.props.headerClassName)}
                      numeric={field.props.textAlign === 'right'}
                      padding="none"
                      variant="head"
                    >
                      {tableCounters[field.props.source]}
                    </TableCell>
                  ) : null;
                }
              )}
            </TableRow>
          </TableHead>}
          <TableHead>
            <TableRow className={classes.row}>
              {hasBulkActions && (
                <TableCell padding="none">
                  <Checkbox
                    className="select-all"
                    color="primary"
                    checked={
                      selectedIds.length > 0 &&
                      ids.length > 0 &&
                      !ids.find(
                        it => selectedIds.indexOf(it) === -1
                      )
                    }
                    onChange={this.handleSelectAll}
                  />
                </TableCell>
              )}

              {(create || edit ) && (
                <TableCell
                  className={classes.headerCell}
                  key='editActions'
                  //resource={resource}
                  style={{
                    color: '#2c9bc3',
                    width: '31px',
                    padding: 0
                  }}
                >
                  {create  && (<AddButton click={this.toggleDrawer('create', true)}/>)}
                </TableCell>
              )}

              {React.Children.map(
                children,
                (field, index) => {
                  const customStyles = field.props.customstyles ? field.props.customstyles : null;
                  return field ? (
                    <DatagridHeaderCell
                      className={classes.headerCell}
                      currentSort={currentSort}
                      field={field}
                      isSorting={
                        field.props.source ===
                        currentSort.field
                      }
                      key={field.props.source || index}
                      resource={resource}
                      updateSort={this.updateSort}
                      style={customStyles}
                    />
                  ) : null;
                }
              )}
            </TableRow>
          </TableHead>
          <DatagridBody
            basePath={basePath}
            classes={classes}
            data={data}
            hasBulkActions={hasBulkActions}
            hover={hover}
            ids={ids}
            isLoading={isLoading}
            onToggleItem={onToggleItem}
            resource={resource}
            rowStyle={rowStyle}
            selectedIds={selectedIds}
            version={version}
          >
            {edit && (<SecretaryEditButton
              style={{ textAlign: 'center' }}
              label=""
              click={this.toggleDrawer}
              source="id"
              customstyles={{
                color: '#2c9bc3',
                width: '35px'
              }}
            />)}

            { create && !edit && (<TextField source="id"/>)}


            {React.Children.map(
              children,
              field => {
                const cellStyles = field.props.cellstyles ? field.props.cellstyles : null;
                field = React.cloneElement(field, {className: "sc-basic-cell", style: cellStyles})
                return field;
              }
            )}
          </DatagridBody>
        </Table>}
      </div>
    );
  }
}

Datagrid.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node.isRequired,
  classes: PropTypes.object,
  className: PropTypes.string,
  currentSort: PropTypes.shape({
    sort: PropTypes.string,
    order: PropTypes.string,
  }).isRequired,
  data: PropTypes.object.isRequired,
  hasBulkActions: PropTypes.bool.isRequired,
  hover: PropTypes.bool,
  ids: PropTypes.arrayOf(PropTypes.any).isRequired,
  isLoading: PropTypes.bool,
  onSelect: PropTypes.func,
  onToggleItem: PropTypes.func,
  resource: PropTypes.string,
  rowStyle: PropTypes.func,
  selectedIds: PropTypes.arrayOf(PropTypes.any).isRequired,
  setSort: PropTypes.func,
  total: PropTypes.number,
  version: PropTypes.number,
  create: PropTypes.func,
  edit: PropTypes.func,
  editopen: PropTypes.bool,
  createopen: PropTypes.bool,
  triggercreate: PropTypes.func,
  triggeredit: PropTypes.func,
  refreshView: PropTypes.func,
  showCounters: PropTypes.bool
};

Datagrid.defaultProps = {
  data: {},
  hasBulkActions: false,
  ids: [],
  selectedIds: [],
  showCounters: false
};

Datagrid = withStyles(tableStyles)(Datagrid);

export default connect(state => ({
  createopen: state.sc.createopen,
  editopen: state.sc.editopen,
  tableCounters: state.sc.tableCounters
}), {
  triggercreate: triggerCreateAction,
  triggeredit: triggerEditAction,
  refreshView: refreshViewAction,
  showNotification
})(Datagrid);



// WEBPACK FOOTER //
// ./src/components/ejected/Datagrid.js